const ACCOUNT_NOT_VERIFIED = 'account_is_not_verified'
const CORRECTION_IN_REQUEST = 'correction_in_request'
const DATA_ALREADY_EXIST = 'data_already_exist'
const DATA_NOT_EXIST = 'data_not_exist'
const DATA_ON_PROCESS = 'duplicate_pending_request'
const DUPLICATE_DATA = 'duplicate_data'
const PRODUCT_SKU_EXIST = 'product_sku_store_already_exists'
const LAST_BILL_MUST_PAY_DELIVERY = 'last_bill_must_pay_delivery'
const LAST_BILL_MUST_PAY_DELIVERY_INSURANCE = 'last_bill_must_pay_delivery_insurance'
const EXPECTED_AMOUNT = 'expectedAmount'
const RETUR_CANNOT_BE_USED_WITH_DP = 'retur_cannot_be_used_with_dp'

export {
  ACCOUNT_NOT_VERIFIED,
  CORRECTION_IN_REQUEST,
  DATA_ALREADY_EXIST,
  DATA_NOT_EXIST,
  DATA_ON_PROCESS,
  DUPLICATE_DATA,
  PRODUCT_SKU_EXIST,
  LAST_BILL_MUST_PAY_DELIVERY,
  LAST_BILL_MUST_PAY_DELIVERY_INSURANCE,
  EXPECTED_AMOUNT,
  RETUR_CANNOT_BE_USED_WITH_DP,
}
